import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import ClientLayout from './template/ClientLayout';
import SidebarLayout from './template/SidebarLayout';


import AllBusinessesPage from './pages/Businesses/AllBusinessesPage';
import BusinessDetailsPage from './pages/Businesses/BusinessDetailsPage';
import CompleteBusiness from './pages/Businesses/CompleteBusiness';
import SignUpBusiness from './pages/Businesses/SignUpBusiness';
import UpdateBusiness from './pages/Businesses/UpdateBusiness';

import Login from './pages/AuthAccount/Login';
import ProfilePage from './pages/AuthAccount/ProfilePage';


import SalesRepManagement from './pages/SalesReps/SalesRepManagement';

import LogsPage from './pages/Logs/LogsPage';
import NotFoundPage from './pages/NotFound/NotFoundPage';
import RolesManagement from './pages/Roles/RolesManagement';
import TrashPage from './pages/Trash/TrashPage';
import UsersList from './pages/Users/UsersList';

import DocumentsPage from './pages/Documents/DocumentsPage';


import CategoriesManagement from './pages/ClientsSupplies/CategoriesManagement';
import ClientsFinishedOrders from './pages/ClientsSupplies/ClientsFinishedOrders';
import ClientsOrders from './pages/ClientsSupplies/ClientsOrders';
import CreateOrder from './pages/ClientsSupplies/CreateOrder';
import OrderDetails from './pages/ClientsSupplies/OrderDetails';
import OrderDetailsUnAssigned from './pages/ClientsSupplies/OrderDetailsUnAssigned';
import SuppliesManagement from './pages/ClientsSupplies/SuppliesManagement';
import Warehouse from './pages/ClientsSupplies/Warehouse';
import Dashboard from './pages/Dashboard';
import FacilitiesPage from './pages/Facilities/Facilities';
import InsuranceCategories from './pages/Insurance/InsuranceCategories';
import Insurances from './pages/Insurance/Insurances';
import AllLabLocationsPage from './pages/Labs/AllLabLocationsPage';
import PSCLocationsPage from './pages/PscLocation/PSCLocationsPage';
import PrivateRoute from './PrivateRoute';

import CategorySuppliesPage from './pages/ClientsSupplies/CategorySuppliesPage';
import CreateOrderInternal from './pages/ClientsSupplies/CreateOrderInternal';
import PrintOrderPage from './pages/ClientsSupplies/PrintOrderPage';
import AllCouriers from './pages/Couriers/AllCouriers';
import CourierDetails from './pages/Couriers/CourierDetails';
import Schedules from './pages/Couriers/Schedules';
import LeaveRequestsPage from './pages/CouriersLeaveRequests/LeaveRequestsPage';
import CreateTemplate from './pages/Emails/CreateTemplate';
import EditTemplate from './pages/Emails/EditTemplate';
import EmailTemplates from './pages/Emails/EmailTemplates';
import FacilitiesStatsByCityPage from './pages/Facilities/FacilitiesStatsByCityPage';
import FacilityDetailsPage from './pages/Facilities/FacilityDetailsPage';
import PickupsStatsByCountyPage from './pages/Facilities/PickupsStatsByCountyPage';
import InventoryLevels from './pages/Inventory/InventoryLevels';
import ReceiveInventory from './pages/Inventory/ReceiveInventory';
import TransactionsHistory from './pages/Inventory/TransactionsHistory';
import Warehouses from './pages/Inventory/Warehouses';
import Map from './pages/Map/Map';
import MessagesList from './pages/Messages/MessagesList';
import AllPickups from './pages/Pickups/AllPickups';
import CourierPickups from './pages/Pickups/CourierPickups';
import FinishedPickups from './pages/Pickups/FinishedPickups';
import ReceivePickups from './pages/Pickups/ReceivePickups';
import RequestPickup from './pages/Pickups/RequestPickup';
import ViewPickup from './pages/Pickups/ViewPickup';
import MonthlyPickupsReport from './pages/Reports/MonthlyPickupsReport';
import Report from './pages/Reports/Report';

import AllCars from './pages/Cars/AllCars';
import CarDetails from './pages/Cars/CarDetails';
import AbnTemplatesPage from './pages/Reqs/abnTemplates/AbnTemplatesPage';
import CoveragePage from './pages/Reqs/icd-10/CoveragePage';
import PanelsPage from './pages/Reqs/panels/PanelsPage';
import PatientCreatePage from './pages/Reqs/patients/PatientCreatePage';
import PatientEditPage from './pages/Reqs/patients/PatientEditPage';
import PatientProfile from './pages/Reqs/patients/PatientProfile';
import PatientsPage from './pages/Reqs/patients/PatientsPage';
import PatientValidationPage from './pages/Reqs/patients/PatientValidationPage';
import CreatePhysicianPage from './pages/Reqs/physicians/CreatePhysicianPage';
import PhysicianEditPage from './pages/Reqs/physicians/PhysicianEditPage';
import PhysicianSignPage from './pages/Reqs/physicians/PhysicianSignPage';
import PhysiciansPage from './pages/Reqs/physicians/PhysiciansPage';
import PhysicianViewPage from './pages/Reqs/physicians/PhysicianViewPage';
import TestCategoriesPage from './pages/Reqs/testCategories/TestCategoriesPage';
import CreateTestOrderPage from './pages/Reqs/testOrder/CreateTestOrderPage';
import TestOrdersPage from './pages/Reqs/testOrder/TestOrdersPage';
import TestCatalogPage from './pages/Reqs/tests/TestCatalogPage';
import EditRolePage from './pages/Roles/EditRolePage';
import AllRoutes from './pages/Routes/AllRoutes';
import AllRoutesPickups from './pages/Routes/AllRoutesPickups';
import ViewRoute from './pages/Routes/ViewRoute';
import SalesRepClients from './pages/SalesReps/SalesRepClients';
import SchedulePage from './pages/Schedules/SchedulePage';
import ViewSchedulePage from './pages/Schedules/ViewSchedulePage';
import ShipmentsList from './pages/Shipments/ShipmentsList';
import PriceCalculator from './pages/TestsPrices/PriceCalculator';
import Prices from './pages/TestsPrices/Prices';
import TestsPricesCategories from './pages/TestsPrices/TestsPricesCategories';
import NewTransaction from './pages/Transactions/NewTransacion';
import SubscriptionDetailsPage from './pages/Transactions/SubscriptionDetailsPage';
import SubscriptionsPage from './pages/Transactions/SubscriptionsPage';
import TransactionDetails from './pages/Transactions/TransactionDetailsPage';
import TransactionsPage from './pages/Transactions/TransactionsPage';
import Landing from './template/HomePage/Landing';



import BSSClientsPage from './pages/BSS/BSSClientsPage';

import BSSCOCsPage from './pages/BSS/BSSCOCsPage';
import BSSSampleSizeChartsPage from './pages/BSS/BSSSampleSizeChartsPage';
import BSSSampleTypesPage from './pages/BSS/BSSSampleTypesPage';
import BSSTestingTypesPage from './pages/BSS/BSSTestingTypesPage';










import BoxLabelPrint from './pages/Others/BoxLabelPrint';
import LabelsNames from './pages/Others/LabelsNames';


function App() {
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />

        {/* Protected Routes */}
        <Route element={<PrivateRoute><SidebarLayout /></PrivateRoute>}>
          {/* Main Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* Other Protected Routes */}
          <Route path="/signup" element={<SignUpBusiness />} />

          <Route path="/sales-reps-managements" element={<SalesRepManagement />} />
          <Route path="/sales-reps/:id/clients" element={<SalesRepClients />} />

          <Route path="/all-businesses" element={<AllBusinessesPage />} />
          <Route path="/business-details/:id" element={<BusinessDetailsPage />} />
          <Route path="/edit-business/:id" element={<UpdateBusiness />} />
          <Route path="/account" element={<ProfilePage />} />
          <Route path="/users" element={<UsersList />} />
          <Route path="/roles" element={<RolesManagement />} />
          <Route path="/roles/:id" element={<EditRolePage />} />
          <Route path="/logs" element={<LogsPage />} />
          <Route path="/trash" element={<TrashPage />} />
          <Route path="/documents" element={<DocumentsPage />} />
          <Route path="/supplies-categories" element={<CategoriesManagement />} />
          <Route path="/supplies/:categoryId" element={<CategorySuppliesPage />} />
          <Route path="/supplies-items" element={<SuppliesManagement />} />
          <Route path="/clients-orders" element={<ClientsOrders />} />
          <Route path="/clients-finished-orders" element={<ClientsFinishedOrders />} />
          <Route path="/order-details/:id" element={<OrderDetails />} />
          <Route path="/order-details-unassigned/:id" element={<OrderDetailsUnAssigned />} />
          <Route path="/print/:id" element={<PrintOrderPage />} />


          <Route path="/warehouses" element={<Warehouse />} />
          <Route path="/labs" element={<AllLabLocationsPage />} />
          {/* FacilitiesStatsByCityPage */}

          <Route path="/facilities" element={<FacilitiesPage />} />
          <Route path='/facilities/:id' element={<FacilityDetailsPage />} />
          <Route path='/facilities/stats/:labId' element={<FacilitiesStatsByCityPage />} />
          <Route path='/facilities/stats-county/:labId' element={<PickupsStatsByCountyPage />} />

          <Route path="/pscs" element={<PSCLocationsPage />} />
          <Route path="/insurance-categories" element={<InsuranceCategories />} />
          <Route path="/insurance" element={<Insurances />} />
          <Route path="/test-prices-categories" element={<TestsPricesCategories />} />
          <Route path="/test-prices" element={<Prices />} />
          <Route path="/test-prices/calculator" element={<PriceCalculator />} />

          {/* Couriers */}
          <Route path="/couriers/couriers" element={<AllCouriers />} />
          <Route path="/couriers/leave-requests" element={<LeaveRequestsPage />} />

          <Route path="/cars" element={<AllCars />} />
          <Route path="/car/details/:id" element={<CarDetails />} />

          {/* Routes */}
          <Route path="/routes/routes" element={<AllRoutes />} />
          <Route path="/routes/routes-pickups" element={<AllRoutesPickups />} />
          <Route path="/routes/view/:routeId" element={<ViewRoute />} />

          {/* Pickups */}
          <Route path="/pickups" element={<AllPickups />} />
          <Route path="/pickups/finished" element={<FinishedPickups />} />
          <Route path="/pickups/request" element={<RequestPickup />} />
          <Route path="/pickups/receive" element={<ReceivePickups />} />
          <Route path="/pickups/view/:id" element={<ViewPickup />} />
          <Route path="/pickups/courier/:id" element={<CourierPickups />} />
          <Route path="/map" element={<Map />} />

          {/* Inventory */}
          <Route path="/inventory/levels/:warehouseId" element={<InventoryLevels />} />
          <Route path="/inventory/receive/:warehouseId" element={<ReceiveInventory />} />
          <Route path="/inventory/transactions/:warehouseId" element={<TransactionsHistory />} />
          <Route path="/inventory" element={<Warehouses />} />

          {/* Others */}
          <Route path="/labels-names" element={<LabelsNames />} />
          <Route path="/dls-label" element={<BoxLabelPrint />} />


          {/* Email Templates */}
          <Route path="/email" element={<EmailTemplates />} />
          <Route path="/email/create" element={<CreateTemplate />} />
          <Route path="/email/edit/:id" element={<EditTemplate />} />

          <Route path="/create-order-internal" element={<CreateOrderInternal />} />
          <Route path="/reports" element={<Report />} />
          <Route path="/pickup-reports" element={<MonthlyPickupsReport />} />


          {/* Messages */}
          <Route path="/messages" element={<MessagesList />} />

          {/* Shipments */}
          <Route path="/shipments" element={<ShipmentsList />} />

          <Route path="/couriers/schedules" element={<Schedules />} />
          <Route path="/couriers/details/:id" element={<CourierDetails />} />

          {/* NEW SCH */}
          <Route path="/schedules" element={<SchedulePage />} />
          <Route path="/view-schedules" element={<ViewSchedulePage />} />

          {/* Transactions */}
          <Route path="/transactions" element={<TransactionsPage />} />
          <Route path="/new-transactions" element={<NewTransaction />} />
          <Route path="/transaction/:id" element={<TransactionDetails />} />
          <Route path="/transaction/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/transaction/subscription/:id" element={<SubscriptionDetailsPage />} />














          {/* //////////////////////////////////////////////////////////////// */}

          {/* Physicians */}
          <Route path="/reqs/physicians" element={<PhysiciansPage />} />
          <Route path="/reqs/physicians/create" element={<CreatePhysicianPage />} />
          <Route path="/reqs/physicians/view/:id" element={<PhysicianViewPage />} />
          <Route path="/reqs/physicians/edit/:id" element={<PhysicianEditPage />} />

          {/* Patients */}
          <Route path="/reqs/patients" element={<PatientsPage />} />
          <Route path="/reqs/patients/create" element={<PatientCreatePage />} />
          <Route path="/reqs/patients/view/:id" element={<PatientProfile />} />
          <Route path="/reqs/patients/edit/:id" element={<PatientEditPage />} />
          {/* Test Categories */}
          <Route path="/reqs/test/categories" element={<TestCategoriesPage />} />
          <Route path="/reqs/test/coverage" element={<CoveragePage />} />
          <Route path="/reqs/test/catalog" element={<TestCatalogPage />} />


          <Route path="/reqs/panels" element={<PanelsPage />} />


          <Route path="/reqs/orders/list" element={<TestOrdersPage />} />
          <Route path="/reqs/orders/create" element={<CreateTestOrderPage />} />

          {/* //////////////////////////////////////////////////////////////// */}

          {/* ABM Template */}
          <Route path="/reqs/abn" element={<AbnTemplatesPage />} />














          {/* //////////////////////////////////////////////////////////////// */}
          {/* //////////////////////////////////////////////////////////////// */}
          {/* //////////////////////////BRIGHTSIDE//////////////////////////// */}
          {/* //////////////////////////////////////////////////////////////// */}
          {/* //////////////////////////////////////////////////////////////// */}
          {/* //////////////////////////////////////////////////////////////// */}







          <Route path="/bss/clients" element={<BSSClientsPage />} />

          <Route path="/bss/sample-types" element={<BSSSampleTypesPage />} />
          <Route path="/bss/sample-size-charts" element={<BSSSampleSizeChartsPage />} />
          <Route path="/bss/testing-types" element={<BSSTestingTypesPage />} />
          <Route path="/bss/cocs" element={<BSSCOCsPage />} />


        </Route>

        {/* Client Non-Protected Routes */}
        <Route element={<ClientLayout />}>
          <Route path="/complete-business/:token" element={<CompleteBusiness />} />
          <Route path="/create-order" element={<CreateOrder />} />
          <Route path="/ph-sign/:token" element={<PhysicianSignPage />} />
          <Route path="/pa-sign/:token" element={<PatientValidationPage />} />
        </Route>

        {/* 404 Route */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}


export default App;
